<template>
  <v-dialog v-model="show" max-width="640">
    <template v-slot:activator="{ on }">
      <v-btn class="mt-2" v-on="on">
        доставка
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Данные для доставки</v-card-title>
      <v-card-text>
        <v-text-field v-model="delivery.name" label="Имя покупателя" />
        <v-text-field v-model="delivery.phone" label="Телефон" />
        <v-text-field v-model="delivery.address" label="Адрес" />
      </v-card-text>
      <v-card-actions>
        <v-btn color="green" @click="save" dark>Сохранить </v-btn>
        <v-btn text @click="close">Отмена</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { normPhoneNumber, trimPhoneNumber } from "@/lib/phone";

export default {
  name: "DeliveryForm",
  props: ["value"],
  data() {
    return {
      delivery: { ...this.value },
      show: false
    };
  },
  methods: {
    save() {
      if (this.delivery.name || this.delivery.phone || this.delivery.address) {
        if (this.delivery.phone) {
          const p =
            "+7" +
            trimPhoneNumber(normPhoneNumber(this.delivery.phone)).substr(0, 10);
          this.delivery.phone = this.$options.filters.phone(p);
        }

        this.$emit("add-delivery", { ...this.delivery });
        this.show = false;
      }
    },
    close() {
      this.delivery = { ...this.value };
      this.show = false;
    }
  }
};
</script>
